<template>
  <div class="login-footer">
    <div>
      <span><svg-icon icon="mingcute:phone-line" />{{ store?.oemBrandDTO?.phone||defaultSetting?.servicePhone||'——' }}</span>
      <span><svg-icon icon="mingcute:location-line" />{{ store?.oemBrandDTO?.address ||settings?.address||'——' }}</span>
      <span><svg-icon icon="ci:mail" />{{ store?.oemBrandDTO?.email||defaultSetting?.legalEmail||'——' }}</span>
    </div>
    <div>
      <span>ICP备案号：<a href="https://beian.miit.gov.cn/" target="_blank">{{ store?.oemDnDTO?.recordNumber || settings.caseNumber }}</a></span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SvgIcon } from '..';
import { settings, getSystemPlatformWithLogin } from '@core/api';

import { useLocalStorage } from '@vueuse/core';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';

const store = useLocalStorage(
  settings.oemkeys,
  {} as any,
);

const defaultSetting = ref({} as any);

async function queryDefault() {
  try {
    let { platformInfo } = await getSystemPlatformWithLogin();

    defaultSetting.value = platformInfo || {};
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

queryDefault();

</script>

<style lang="scss" scoped>
.login-footer {
  position: fixed;
  bottom: 40px;
  font-size: 14px;
  color: #6b7891;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > div {
    margin-bottom: 12px;
    display: flex;

    span {
      display: flex;
      align-items: center;
      margin-right: 24px;
      margin-left: 24px;
    }

    .svg-icon {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
